import React, { Component } from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';
import getToken from '../../../../../../utility/getToken';
import UserFilesAndFoldersController from '../../../../../../utility/userFilesAndFolderController';

const InputWrapp = styled.div``;

const RenameWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const SpanWrap = styled.span`
  display: inline-block;
  visibility: hidden;
  white-space: pre;
  max-width: 180px;
  padding: 0px 10px;
`;

const EditDocumentName = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  width: 100%;
  text-align: center;
  padding: 0px 6px;
  border: 1px solid #473880;
  font-size: 12px;
  border-radius: 2px;

  &:focus {
    outline: none;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
export default class RenameDocuments extends Component {
  constructor(props) {
    super(props);
    const { documentName } = this.props;
    this.state = {
      value: documentName,
    };
  }

  inputRef = React.createRef();

  componentDidMount = () => {
    this.inputRef.current.focus();
    const { documentName } = this.props;
    const defaultTitle = documentName;
    document.addEventListener('mousedown', (e) => {
      this.handleMousedown(e, defaultTitle);
    });
  };

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleMousedown);
  };

  handleMousedown = (e) => {
    if (this.inputRef.current && !this.inputRef.current.contains(e.target)) {
      const { isEditing, handleUpdateIsEditing } = this.props;

      if (isEditing) {
        this.renameItem();
        handleUpdateIsEditing(false);
      }
    }
  };

  renameItem = async () => {
    const { nodeId, handleUpdateDocumentName, handelSnackBar } = this.props;

    const { value } = this.state;

    let response = { status: false, message: 'Please enter name' };

    if (value !== '') {
      const data = {
        name: value.toLowerCase(),
        originalName: value,
        nodeId,
      };
      const token = await getToken();
      try {
        response = await UserFilesAndFoldersController.renameItem(data, token);
      } catch (err) {
        response.status = false;
        response.message = 'Something went wrong, please try again';
      }

      handelSnackBar(response);
      handleUpdateDocumentName(response, value);
    }
  };

  handleChange = (e) => {
    const { handleChange } = this.props;
    this.setState({ value: e.target.value });
    handleChange(e);
  };

  render() {
    const { value } = this.state;
    return (
      <>
        <InputWrapp>
          <RenameWrapper>
            <SpanWrap className="text">{value}</SpanWrap>
            <EditDocumentName
              ref={this.inputRef}
              value={value}
              onChange={this.handleChange}
            />
          </RenameWrapper>
        </InputWrapp>
      </>
    );
  }
}
